import React, { useState, useEffect } from "react";
import Sub_header from './Sub_header'

import axios from "axios";


import exportValue from "../apiconfig";
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2'
import Left_panel from "./Left_panel";
// import '../../components/loader.css';


const B2b_rate_calculator = () => {
  const [productList, setproductList] = useState([]);
  console.log("productList == ", productList)
  const [volstate, setVolstate] = React.useState(null)
  const [stateloading, setloadingstate] = useState({ isloading: false })
  const [setvisible, setvisiblestate] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [parceltype, setparceltypeState] = React.useState({ parcel: true })
  const [documenttype, setdocumenttypeState] = React.useState({ document: false })
  const [state, setState] = React.useState({ parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", mode: "Domestic", weight: "", length: "", width: "", height: "", country_name: "", shipment_value: "" })
  const [paymentmode, setpaymentmode] = React.useState({ mode: 1 })
  const [codvalue, setcodvalue] = React.useState({ cod_amount: 0, err: {} })
  const [volume, setVolume] = React.useState()
  const [riskstate, setriskstate] = useState({ risk: 2 })
  const [selfstate, setselfstate] = React.useState({
    self: 1
  });
  const [boxDetails, setBoxDetails] = React.useState(
    [{
      box_name: '',
      box_length: '',
      box_width: '',
      box_height: '',
      box_weight: '',
      quantity: ''
    }]
  );
  const [boxErrors, setBoxErrors] = React.useState([]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
  const getProductList = (index = 0) => {
    const newBoxErrors = [];
    boxDetails.forEach((box, index) => {
      const errors = {};
      if (!box.box_length) errors.box_length = 'Length is required';
      if (!box.box_width) errors.box_width = 'Width is required';
      if (!box.box_height) errors.box_height = 'Height is required';
      if (!box.box_weight) errors.box_weight = 'Weight is required';
      if (!box.quantity) errors.quantity = 'Quantity is required';
      // if (!box.product_name) errors.product_name = 'Product Name is required';
      // if (!box.unit_price) errors.unit_price = 'Unit price is required';
      newBoxErrors[index] = errors;
    });
    setBoxErrors(newBoxErrors);

    if (newBoxErrors.some(errors => Object.keys(errors).length > 0)) {
      return;
    }

    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000
    })
    setloadingstate({ isloading: true })
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/b2b_search_zone`;
    let sendData = {
      from_postal_code: state.from_postal_code,
      to_postal_code: state.to_postal_code,
      weight: boxDetails.reduce((sum, box) => {
        return Number(sum) + Number(box.box_weight * box.quantity);
      }, 0),
      length: state.length,
      height: state.height,
      width: state.width,
      shipment_value: state.shipment_value,
      insurance: riskstate.risk,
      //  sort_by:sort ,
      boxes: boxDetails,
      parcel_type: state.parcel_type,
      mode: state.mode,
      payment_mode: paymentmode.mode == 2 ? "cod" : "prepaid",
      order_amount: codvalue.cod_amount,
      carrier_type: 2,

      from_country_code: "IN",


      to_country_code: "IN", self: selfstate.self
    }

    if (state.from_postal_code != "" && state.to_postal_code != "" && state.mode != "" && state.parcel_type != "" && state.shipment_value != "") {
      if (paymentmode.mode == 1 || paymentmode.mode == 2 && codvalue.cod_amount != "") {
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
          console.log("res ", res);
          if (res.data.status == "success") {
            setproductList(res.data.output)
            setloadingstate({ isloading: false })
            setvisiblestate(true)
          }
          else {

            setloadingstate({ isloading: false })
            setvisiblestate(true)
          }


        }).catch((e) => {
          Toast.fire({
            background: "#206bc4",
            type: 'unsuccess',
            title: "Something went wrong",
            color: "white"
          });


        });
      }
      else {
        Toast.fire({
          background: "#a61c09",
          type: 'unsuccess',
          title: "Please enter cod value",
          color: "white"
        });
        setloadingstate({ isloading: false })

      }
    }
    else {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      Toast.fire({
        background: "#a61c09",
        type: 'Unsuccess',
        title: "Please Fill All the Fields",
        color: "white"
      });
      setloadingstate({ isloading: false })

    }
  }

  const handleChange = (e) => {
    console.log("namess", e.target.name)
    console.log("value", e.target.value)
    console.log("type", e.target.type)


    let names = e.target.name
    let value = e.target.value

    if (e.target.type == "text") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "select-one") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "radio") {
      if (e.target.checked == true) {

        if (e.target.name == "document") {
          setparceltypeState({ ...parceltype, parcel: false })
          setdocumenttypeState({ ...documenttype, document: true })
          setState({ ...state, parcel_type: "Document" })
        }
        else {
          setparceltypeState({ ...parceltype, parcel: true })
          setdocumenttypeState({ ...documenttype, document: false })
          setState({ ...state, parcel_type: "Parcel" })
        }
      }
    }
    else if (e.target.type == "number") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "date") {
      setState({ ...state, [e.target.name]: value })

    }
  }

  const reset = () => {
    setState({ ...state, parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", mode: "Domestic", weight: "", length: "", width: "", height: "", country_name: "" })
    setdocumenttypeState({ ...documenttype, document: false })
    setparceltypeState({ ...parceltype, parcel: true })
    setcodvalue({ ...codvalue, cod_amount: 0, err: {} })
  }
  const payment_mode = (e) => {
    if (e.target.name == "prepaid") {
      setpaymentmode({ mode: 1 })
    }
    else {
      setpaymentmode({ mode: 2 })
    }
  }
  const codvalueChange = (e) => {

    setcodvalue({ ...codvalue, cod_amount: e.target.value, err: {} })
  }


  React.useEffect(() => {
    if (state.height !== "" && state.width !== "" && state.length !== "") {
      let divisor = 5000
      const calculatedVolume = (state.height * state.width * state.length) / divisor;
      setVolume(calculatedVolume.toFixed(2));
    } else {
      setVolume(0);
    }
  }, [state.height, state.width, state.length, volstate]);

  const risk_mode = (e) => {
    if (e.target.name == "owner_risk") {
      setriskstate({ risk: 1 })
    }
    else {
      setriskstate({ risk: 2 })
    }
  }
  const self_mode = (e) => {
    if (e.target.name == "self_pickup") {
      setselfstate({ self: 1 })
    }
    else {
      setselfstate({ self: 2 })
    }
  }
  const handleAddBox = () => {
    setBoxDetails([
      ...boxDetails,
      {
        box_length: '',
        box_width: '',
        box_height: '',
        box_weight: '',
        quantity: '',
      },
    ]);
  };
  const handleRemoveBox = (indexToRemove) => {
    const updatedBoxes = boxDetails.filter((_, index) => index !== indexToRemove);
    setBoxDetails(updatedBoxes);
  };
  const handleBoxDimensionChange = (event, key, index) => {

    const value = key === 'quantity' || key === 'unit_price' ? parseFloat(event.target.value) : event.target.value;
    setBoxDetails(prevState => {
      const newState = [...prevState];
      newState[index][key] = value;
      return newState;
    });
  };
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section class="home-section">
        {/* <?php
               include('sub_header.php');
               ?>  */}

        <Sub_header />

        <div className=''>
          <div class="col-12 col-md-2 mt-2">
            <h5>Rate Calculator</h5>
          </div>

          <div class="col-12 col-md-10">
            <div class="card border-0 order_box shadow-sm">
              <div class="card-body">
                <section class="pb-5">
                  <div class="row">
                    <div class="col-12 col-md-12 mb-3">
                      <label for="" class="form-label">Shipment Type:</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" onChange={(e) => handleChange(e)} name="document" id="inlxineRadio1" checked={documenttype.document == true && parceltype.parcel == false} />
                          <label class="form-check-label" for="inlineRadio1">Document</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="parcel" onChange={(e) => handleChange(e)} id="inlixneRadio2" value={state.parcel_type} checked={parceltype.parcel == true && documenttype.document == false} />
                          <label class="form-check-label" for="inlineRadio2">Parcel</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                      <label for="" class="form-label">Pickup Pincode:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter pickup pincode" name="from_postal_code" value={state.from_postal_code} onChange={(e) => handleChange(e)} />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                      <label for="" class="form-label">Delivery Pincode:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter delivery pincode" name="to_postal_code" value={state.to_postal_code} onChange={(e) => handleChange(e)} />
                    </div>
                    {boxDetails.map((box, index) => (
                      <div class="card mb-2" key={index} >
                        <div class="card-body">
                          <section class="">
                            <h6 class="mb-4">Box {index + 1} Detail</h6>
                            <div class="row">

                              <div class="col-12 col-md">
                                <label for="" class="form-label">Box Dimensions (CM):</label>
                                <div class="row g-1">
                                  <div class="col-12 col-md mb-2">
                                    <input type="number" className="form-control" id="" placeholder="Length" value={box.box_length} onChange={(e) => handleBoxDimensionChange(e, 'box_length', index)} />
                                    <span>{boxErrors[index]?.box_length}</span>
                                  </div>
                                  <div class="col-12 col-md mb-2">
                                    <input type="number" class="form-control" id="" placeholder="Width" name="" value={box.box_width} onChange={(e) => handleBoxDimensionChange(e, 'box_width', index)} />
                                    <span>{boxErrors[index]?.box_width}</span>
                                  </div>
                                  <div class="col-12 col-md mb-2">
                                    <input type="number" class="form-control" id="" placeholder="Height" name="" value={box.box_height} onChange={(e) => handleBoxDimensionChange(e, 'box_height', index)} />
                                    <span>{boxErrors[index]?.box_height}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <label for="" class="form-label">Box Weight(KG):</label>
                                <input type="number" class="form-control" id="" placeholder="Enter Weight" name="" value={box.box_weight} onChange={(e) => handleBoxDimensionChange(e, 'box_weight', index)} />
                                <span>{boxErrors[index]?.box_weight}</span>
                              </div>
                              <div class="col-12 col-md-2">
                                <label for="" class="form-label">Box Quantity:</label>
                                <input type="number" class="form-control" id="" placeholder="Enter quantity" name="" value={box.quantity} onChange={(e) => handleBoxDimensionChange(e, 'quantity', index)} />
                                <span>{boxErrors[index]?.quantity}</span>
                              </div>
                            </div>
                          </section>
                          <section class="pb-3">
                            <div class="row">

                              <div class="col-12 col-md-2 mb-3">
                                {index === 0 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-success btn-sm"
                                      style={{ marginTop: "30px" }}
                                      onClick={handleAddBox}
                                    >
                                      Add Box
                                    </button>
                                  </>) : (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    style={{ marginTop: "30px" }}
                                    onClick={() => handleRemoveBox(index)}
                                  >
                                    Remove
                                  </button>
                                )}
                              </div>


                            </div>
                          </section>
                        </div>
                      </div>
                    ))}
                    <div class="col-12 col-md-3 mb-3">
                      <label for="" class="form-label">Shipment Value:</label>
                      <div class="input-group">
                        <input type="number" class="form-control" placeholder="Enter Value" name="shipment_value" onChange={(e) => handleChange(e)} value={state.shipment_value} />
                        {/* <span class="input-group-text">KG</span> */}
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-3">
                      <label for="" class="form-label">Mode:</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="cod" id="inlineRadio2" value="option2" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 2} />
                          <label class="form-check-label" for="inlineRadio1">Cash On Delivery</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 1} />
                          <label class="form-check-label" for="inlineRadio2">Prepaid</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                      <label for="" class="form-label">ROV/Insurance:</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="owner_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk == 1} />
                          <label class="form-check-label" for="inlineRadio1">OR (Owner Risk)</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="carrier_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk == 2} />
                          <label class="form-check-label" for="inlineRadio1">CR (Carrier Risk)</label>
                        </div>
                      </div>
                    </div>
                    {paymentmode.mode == 2 ?
                      <div class="row">
                        <div class="col-12 col-md-5 mb-3">
                          <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount"
                            onChange={(e) => codvalueChange(e)} value={codvalue.cod_amount} />
                        </div>
                      </div> : ""}

                    <div class="row mt-4">
                      <div class="col-12 col-md-2 mb-3">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="self_pickup" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 1} />
                          <label class="form-check-label" for="inlineRadio1">Pickup</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-2 mb-3">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="self_drop" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 2} />
                          <label class="form-check-label" for="inlineRadio1">Self Drop</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>

                  <h6 class="mb-3 mt-3">Applicable Weight  <span className='ms-5'>{volume && state.weight !== "" ?
                    (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + " Kg" :
                    "0.00 Kg"
                  }</span> </h6>
                  <div>
                    <a onClick={() => getProductList()} class="btn btn-primary me-2">Calculate</a>
                    <a onClick={() => reset()} class="btn btn-outline-primary">Reset</a>
                  </div>
                </section>
              </div>
            </div>
          </div>


          {stateloading.isloading == true ?
            <div style={{ backgroundColor: "#f1f5f9", zIndex: 2, height: "100%", width: "100%", position: "absolute", opacity: "0.4" }}>
              <div style={{ left: "30%", top: "25%", position: "absolute" }}>
                <ReactLoading type={"spin"} color={"#000000"} height={300} width={89} />
              </div>
            </div> :

            setvisible == true ?
              <div class="card border-0 shadow mt-4 ">
                <div class="card card-body border-0 shadow table-wrapper table-responsive">

                  <table class="table table-hover  shipm_tablew">
                    <thead class="">
                      <tr>
                        <th >Carrier</th>
                        <th >Product</th>
                        {/* <th >Charges</th> */}
                        <th >Carrier Commission</th>
                        {/* <th >Base Rate</th> */}
                        <th >Freight Charges</th>
                        <th >FSC Charges</th>
                        <th >Forward Freight</th>
                        <th >Carrier Risk Charges</th>
                        <th >Owner Risk Charges</th>
                        <th >Cod Charges</th>
                        <th >Waybill Charges</th>
                        <th >FM Charges</th>
                        <th >Green Tax Charges</th>
                        <th >Handling Charges</th>
                        <th >ODA Charges</th>
                        <th>Tech Charges</th>
                        <th>Destination Charges</th>
                        <th >Sub Total</th>
                        <th >GST</th>
                        <th >Total Amount</th>

                      </tr>
                    </thead>

                    <tbody >
                      {productList.map((sub, index) => (
                        <tr className="mt-4">
                          <td>
                            {/* <img src={`https://cdn.thejetpost.in/images/${sub.carrierImage}`} width="100px" /> */}
                            {sub.service_name} </td>
                          <td>{sub.service_provider}</td>

                          {/* <td>{sub.total_charges}</td> */}
                          <td>
                            {sub.commission_charge}
                          </td>
                          {/* <td>{sub.charge_breakdown.base_rate}</td> */}
                          <td>{sub.charge_breakdown.freight_charges}</td>
                          <td>{sub.charge_breakdown.fsc_charges}</td>
                          <td>{sub.charge_breakdown.forward_freight}</td>
                          <td>{sub.charge_breakdown.rov_charges}</td>
                          <td>{sub.charge_breakdown.owner_risk_charge}</td>
                          <td>{sub.charge_breakdown.cod_charges}</td>
                          <td>{sub.charge_breakdown.waybill_charge}</td>
                          <td>{sub.charge_breakdown.fm_charges}</td>
                          <td>{sub.charge_breakdown.green_tax}</td>
                          <td>{sub.charge_breakdown.handling_charges}</td>
                          <td>{sub.charge_breakdown.oda_charges}</td>
                          <td>{sub.charge_breakdown.tech_charge}</td>
                          <td>{sub.charge_breakdown.destination_charge}</td>


                          <td>{sub.charge_breakdown.sub_total}</td>
                          <td>{sub.charge_breakdown.gst}</td>
                          <td>{sub.charge_breakdown.total_amount}</td>



                        </tr>
                      ))}
                    </tbody>


                  </table>

                </div>
              </div>



              : ""}
        </div>
      </section>
    </div>
  )
}

export default B2b_rate_calculator
